(function () {
  'use strict';

  function swallowError(error) {
    if (window.console && typeof window.console.warn === 'function') {
      console.warn('[ga-custom-event]', error);
    }
  }

  function normalizeGaEventName(eventName) {
    return (eventName || '').trim().replace(/\s+/g, '_').toLowerCase();
  }

  function safeCall(fn) {
    try {
      return fn();
    } catch (error) {
      swallowError(error);
      return null;
    }
  }

  function sendGaEvent(eventName, eventData) {
    return safeCall(function () {
      if (typeof window.gtag !== 'function' || !eventName) return;

      if (eventData && typeof eventData === 'object') {
        window.gtag('event', eventName, eventData);
        return;
      }

      window.gtag('event', eventName);
    });
  }

  function parseMoneyValue(priceText) {
    if (!priceText) return null;

    const normalized = String(priceText)
      .replace(/\s/g, '')
      .replace(/[^\d,.-]/g, '');

    if (!normalized) return null;

    const hasComma = normalized.includes(',');
    const hasDot = normalized.includes('.');
    let numericText = normalized;

    if (hasComma && hasDot) {
      if (normalized.lastIndexOf(',') > normalized.lastIndexOf('.')) {
        numericText = normalized.replace(/\./g, '').replace(',', '.');
      } else {
        numericText = normalized.replace(/,/g, '');
      }
    } else if (hasComma) {
      const commaParts = normalized.split(',');
      const lastPart = commaParts[commaParts.length - 1];
      numericText = lastPart.length === 2
        ? normalized.replace(/\./g, '').replace(',', '.')
        : normalized.replace(/,/g, '');
    } else {
      numericText = normalized.replace(/,/g, '');
    }

    const value = Number.parseFloat(numericText);
    return Number.isFinite(value) ? value : null;
  }

  function getCurrentCurrency() {
    return safeCall(function () {
      return window.Shopify?.currency?.active || window.Shopify?.currency?.iso_code || null;
    });
  }

  function getCollectionName() {
    return safeCall(function () {
      const titleElement = document.querySelector('.top-ads-pc-left-title');
      if (titleElement && titleElement.textContent && titleElement.textContent.trim()) {
        return titleElement.textContent.trim();
      }

      const pageTitle = String(document.title || '').split(' - ')[0].trim();
      if (pageTitle) return pageTitle;

      const pathParts = String(window.location.pathname || '').split('/').filter(Boolean);
      return pathParts[pathParts.length - 1] || 'collection';
    }) || 'collection';
  }

  function getProductGrid() {
    return safeCall(function () {
      return document.querySelector('.collection #product-grid');
    });
  }

  function getProductCards(grid) {
    return safeCall(function () {
      if (!grid || typeof grid.querySelectorAll !== 'function') return [];
      return Array.from(grid.querySelectorAll(':scope > li .card-wrapper.product-card-wrapper'));
    }) || [];
  }

  function getCardDatasetValue(card, key) {
    return safeCall(function () {
      return card && card.dataset && typeof card.dataset[key] === 'string'
        ? card.dataset[key].trim()
        : '';
    }) || '';
  }

  function buildListItem(card, index) {
    return safeCall(function () {
      const salePriceElement = card.querySelector('.price__sale .price-item--last');
      const regularPriceElement = card.querySelector('.price__regular .price-item--regular');
      const fallbackPriceElement = card.querySelector('.price-item--last');
      const priceElement = salePriceElement || regularPriceElement || fallbackPriceElement;
      const price = parseMoneyValue(priceElement && priceElement.textContent ? priceElement.textContent : '');

      const itemId = getCardDatasetValue(card, 'gaItemId');
      const itemName = getCardDatasetValue(card, 'gaItemName');

      if (!itemId || !itemName) return null;

      const item = {
        item_id: itemId,
        item_name: itemName,
        item_category: getCardDatasetValue(card, 'gaItemCategory'),
        index: index + 1,
      };

      if (price !== null) {
        item.price = price;
      }

      return item;
    });
  }

  const reportedItemListViews = new Set();
  let collectionTrackingFrame = null;

  function trackCollectionViewItemList() {
    return safeCall(function () {
      if (typeof window.gtag !== 'function') return;
      if (!String(window.location.pathname || '').includes('/collections/')) return;

      const grid = getProductGrid();
      if (!grid) return;

      const cards = getProductCards(grid);
      if (!cards.length) return;

      const itemListName = getCollectionName();
      const currency = getCurrentCurrency();
      const locationKey = String(window.location.pathname || '') + String(window.location.search || '');
      const items = [];

      cards.forEach(function (card, index) {
        const item = buildListItem(card, index);
        if (!item) return;

        const reportKey = locationKey + '::' + item.item_id + '::' + item.index;
        if (reportedItemListViews.has(reportKey)) return;

        reportedItemListViews.add(reportKey);
        items.push(item);
      });

      if (!items.length) return;

      const payload = {
        item_list_name: itemListName,
        items: items,
      };

      if (currency) {
        payload.currency = currency;
      }

      sendGaEvent('view_item_list', payload);
    });
  }

  function scheduleCollectionTracking() {
    return safeCall(function () {
      const runner = function () {
        collectionTrackingFrame = null;
        trackCollectionViewItemList();
      };

      if (typeof window.cancelAnimationFrame === 'function' && collectionTrackingFrame) {
        window.cancelAnimationFrame(collectionTrackingFrame);
      }

      if (typeof window.requestAnimationFrame === 'function') {
        collectionTrackingFrame = window.requestAnimationFrame(runner);
        return;
      }

      window.setTimeout(runner, 0);
    });
  }

  function handleCustomEventClick(event) {
    return safeCall(function () {
      if (!event || !event.target || typeof event.target.closest !== 'function') return;

      const element = event.target.closest('[ga-custom-event]');
      if (!element) return;

      const eventName = normalizeGaEventName(element.getAttribute('ga-custom-event'));
      const eventDataRaw = element.getAttribute('ga-custom-event-data');

      if (!eventName) return;

      if (eventDataRaw) {
        try {
          sendGaEvent(eventName, JSON.parse(eventDataRaw));
        } catch (error) {
          swallowError(error);
          sendGaEvent(eventName);
        }
        return;
      }

      sendGaEvent(eventName);
    });
  }

  function observeCollectionGrid() {
    return safeCall(function () {
      const grid = getProductGrid();
      if (!grid || typeof window.MutationObserver !== 'function') return;

      const observer = new window.MutationObserver(function (mutations) {
        const hasListChange = mutations.some(function (mutation) {
          return mutation && (mutation.addedNodes.length || mutation.removedNodes.length);
        });

        if (hasListChange) {
          scheduleCollectionTracking();
        }
      });

      observer.observe(grid, {
        childList: true,
        subtree: false,
      });
    });
  }

  document.addEventListener('click', handleCustomEventClick, false);

  document.addEventListener('DOMContentLoaded', function () {
    safeCall(function () {
      scheduleCollectionTracking();
      observeCollectionGrid();
    });
  });

  window.addEventListener('popstate', function () {
    scheduleCollectionTracking();
  });

  window.addEventListener('pageshow', function () {
    scheduleCollectionTracking();
  });
}());